import {lazy, Suspense} from 'react';
import {useRoutes, useLocation} from 'react-router-dom';

// guards
import GuestGuard from '../guards/GuestGuard';

// components
import AuthGuard from "../guards/AuthGuard";
import {Splash} from "../pages";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {pathname} = useLocation();

    return (
        <Suspense fallback={<Splash/>}>
            <Component {...props} />
        </Suspense>
    );
};

export default function Router() {
    return useRoutes([
        {
            path: 'auth',
            children: [
                {
                    path: 'login',
                    element: (
                        <GuestGuard>
                            <Login/>
                        </GuestGuard>
                    ),
                },
                {
                    path: 'register',
                    element: (
                        <GuestGuard>
                            <Register/>
                        </GuestGuard>
                    ),
                },
                {
                    path: 'verify',
                    element: (
                        <GuestGuard>
                            <Verify/>
                        </GuestGuard>
                    ),
                },

                {
                    path: 'splash',
                    element: (
                        <GuestGuard>
                            <Splash/>
                        </GuestGuard>
                    ),
                },
            ],
        },
        {
            path: '/',
            element: (
                <AuthGuard>
                    <Home/>
                </AuthGuard>
            ),
        },
        {
            path: 'verify-success',
            element: (
                <AuthGuard>
                    <VerifySuccess/>
                </AuthGuard>
            ),
        },
        {
            path: 'user-information',
            element: (
                <AuthGuard>
                    <UserInfo/>
                </AuthGuard>
            ),
        },
        {
            path: 'activity',
            element: (
                <AuthGuard>
                    <Activity/>
                </AuthGuard>
            ),
        },
        {
            path: 'confirm',
            element: (
                <AuthGuard>
                    <Confirm/>
                </AuthGuard>
            ),
        },
        {
            path: 'support',
            element: (
                <AuthGuard>
                    <Support/>
                </AuthGuard>
            ),
        },
        {
            path: 'diets',
            element: (
                <AuthGuard>
                    <Diets/>
                </AuthGuard>
            ),
        },
        {
            path: 'practices',
            element: (
                <AuthGuard>
                    <Practices/>
                </AuthGuard>
            ),
        },
        {
            path: 'loading',
            element: (
                <AuthGuard>
                    <Loading/>
                </AuthGuard>
            ),
        },
        {
            path: 'programs',
            element: (
                <AuthGuard>
                    <Programs/>
                </AuthGuard>
            ),
        },
        {
            path: 'chat',
            element: (
                <AuthGuard>
                    <Chat/>
                </AuthGuard>
            ),
        },
        {
            path: 'weight-process',
            element: (
                <AuthGuard>
                    <WeightProccess/>
                </AuthGuard>
            ),
        },
        {
            path: 'create-ticket',
            element: (
                <AuthGuard>
                    <TicketForm/>
                </AuthGuard>
            ),
        },
        {
            path: 'tickets',
            element: (
                <AuthGuard>
                    <Tickets/>
                </AuthGuard>
            ),
        },
        {
            path: 'tickets/:ticket',
            element: (
                <AuthGuard>
                    <TicketShow/>
                </AuthGuard>
            ),
        },
        {
            path: 'courses',
            element: (
                <AuthGuard>
                    <Courses/>
                </AuthGuard>
            ),
        },
        {
            path: 'select-diet',
            element: (
                <AuthGuard>
                    <DietType/>
                </AuthGuard>
            ),
        },
        {
            path: 'body-information',
            element: (
                <AuthGuard>
                    <BodyInformation/>
                </AuthGuard>
            ),
        },
        {
            path: 'confirm-purchase/:invoice',
            element: (
                <AuthGuard>
                    <ConfirmPurchase/>
                </AuthGuard>
            ),
        },
        {
            path: 'verify-purchase',
            element: (
                <AuthGuard>
                    <VerifyPurchase/>
                </AuthGuard>
            ),
        },
        {
            path: 'courses/:course',
            element: (
                <AuthGuard>
                    <CourseSingle/>
                </AuthGuard>
            ),
        },
        {
            path: '/profile',
            element: (
                <AuthGuard>
                    <Profile/>
                </AuthGuard>
            ),
        },
        {
            path: '/user-disease',
            element: (
                <AuthGuard>
                    <UserDisease/>
                </AuthGuard>
            ),
        },
    ]);
}
const Login = Loadable(lazy(() => import('../pages/login')));
const Register = Loadable(lazy(() => import('../pages/register')));
const Verify = Loadable(lazy(() => import('../pages/verify')));

// MAIN
const Home = Loadable(lazy(() => import('../pages/home')));
const VerifySuccess = Loadable(lazy(() => import('../pages/verify-success')));
const UserDisease = Loadable(lazy(() => import('../pages/user-disease')));
const TicketShow = Loadable(lazy(() => import('../pages/ticket-show')));
const Diets = Loadable(lazy(() => import('../pages/diets')));
const Support = Loadable(lazy(() => import('../pages/support')));
const Loading = Loadable(lazy(() => import('../pages/loading')));
const Confirm = Loadable(lazy(() => import('../pages/confirm')));
const Programs = Loadable(lazy(() => import('../pages/programms')));
const Chat = Loadable(lazy(() => import('../pages/chat')));
const Practices = Loadable(lazy(() => import('../pages/practices')));
const WeightProccess = Loadable(lazy(() => import('../pages/weight-proccess')));
const TicketForm = Loadable(lazy(() => import('../pages/ticket-form')));
const Tickets = Loadable(lazy(() => import('../pages/tickets')));
const Courses = Loadable(lazy(() => import('../pages/courses')));
const DietType = Loadable(lazy(() => import('../pages/diet-type')));
const BodyInformation = Loadable(lazy(() => import('../pages/body-information')));
const Activity = Loadable(lazy(() => import('../pages/activity')));
const UserInfo = Loadable(lazy(() => import('../pages/user-information')));
const ConfirmPurchase = Loadable(lazy(() => import('../pages/confirm-purchase')));
const VerifyPurchase = Loadable(lazy(() => import('../pages/verify-purchase')));
const CourseSingle = Loadable(lazy(() => import('../pages/course-single')));
const Profile = Loadable(lazy(() => import('../pages/profile')));

